<template>
  <div v-if="!extsItems.length">
    <div class="head-box">
      <div class="c-flex c_flex_center">
        <h4>契约锁PDF管理</h4>
      </div>

      <div class="c-flex c-flex-item">
        <el-input
          placeholder="请输入手机号"
          v-model="searchValue"
          clearable
          @clear="
            fpi.page = 1;
            getData();
          "
          @keyup.enter.native="
            fpi.page = 1;
            getData();
          "
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="
              fpi.page = 1;
              getData();
            "
          ></el-button>
        </el-input>
        <el-button type="primary" @click="doNew" class="c-m-l-10 c-m-r-10">新增</el-button>
      </div>
    </div>
    <div class="content-box">
      <!-- <div class="content-filter">
        <c-filter></c-filter>
      </div> -->
      <div class="content-table">
        <el-table
          ref="table"
          height="calc(100% - 50px)"
          :data="fpi.data"
          highlight-current-row
          border
        >
          <el-table-column prop="url" label="契约锁配置url" min-width="80px"></el-table-column>
          <el-table-column
            prop="accessKey"
            label="契约锁配置accessKey"
            min-width="80px"
          ></el-table-column>
          <el-table-column
            prop="accessSecret"
            label="契约锁配置accessSecret"
            min-width="80px"
          ></el-table-column>
          <el-table-column
            prop="sealId"
            label="契约锁配置印章id"
            min-width="80px"
          ></el-table-column>
          <el-table-column
            prop="companyName"
            label="发起签署方公司名"
            min-width="80px"
          ></el-table-column>
          <el-table-column
            prop="companyType"
            label="发起签署方公司类型"
            min-width="80px"
          ></el-table-column>
          <el-table-column
            prop="companyId"
            label="发起方契约锁公司id"
            min-width="80px"
          ></el-table-column>
          <el-table-column
            prop="phone"
            label="发起签署方接收人手机号"
            min-width="80px"
          ></el-table-column>
          <el-table-column prop="type" label="合同类型" min-width="80px"></el-table-column>
          <el-table-column fixed="right" width="100px">
            <template slot-scope="scope">
              <el-dropdown>
                <el-button>
                  操作
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="doEdit(scope.row)">
                    编辑
                  </el-dropdown-item>
                  <el-dropdown-item @click.native="doSeting(scope.row)">
                    设置
                  </el-dropdown-item>
                  <!-- <el-dropdown-item
                    v-if="
                      (osg.has('Partners,remove') || osg.has('Partners?type=all,remove')) &&
                        state != 'archived'
                    "
                    @click.native="doRemove(scope.row.orgId)"
                  >
                    删除
                  </el-dropdown-item> -->
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="pagination"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="fpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="fpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="fpi.total"
        ></el-pagination>
      </div>
    </div>

    <el-dialog title="信息" :visible.sync="openDetail">
      <el-form
        :model="formData"
        :rules="osg.rules"
        ref="formData"
        label-width="110px"
        label-position="left"
        hide-required-asterisk:true
      >
        <el-form-item label="契约锁配置url" prop="url">
          <el-input v-model="formData.url"></el-input>
        </el-form-item>
        <el-form-item label="契约锁配置accessKey" prop="accessKey">
          <el-input v-model="formData.accessKey"></el-input>
        </el-form-item>
        <el-form-item label="契约锁配置accessSecret" prop="accessSecret">
          <el-input v-model="formData.accessSecret"></el-input>
        </el-form-item>
        <el-form-item label="契约锁配置印章id" prop="sealId">
          <el-input v-model="formData.sealId"></el-input>
        </el-form-item>
        <el-form-item label="发起签署方公司名" prop="companyName">
          <el-input v-model="formData.companyName"></el-input>
        </el-form-item>
        <el-form-item label="发起签署方公司类型" prop="companyType">
          <el-input v-model="formData.companyType"></el-input>
        </el-form-item>
        <el-form-item label="发起方契约锁公司id" prop="companyId">
          <el-input v-model="formData.companyId"></el-input>
        </el-form-item>
        <el-form-item label="发起签署方接收人手机号" prop="phone">
          <el-input v-model="formData.phone"></el-input>
        </el-form-item>
        <el-form-item label="合同类型" prop="type">
          <el-input v-model="formData.type"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="doSave">确 定</el-button>
        <el-button @click="doInit">取 消</el-button>
      </div>
    </el-dialog>
  </div>
  <div v-else>
    <div class="role box c-h-1">
      <div class="left-box">
        <div class="head-box">
          <el-page-header @back="goBack" title="契约锁PDF管理" content="设置"></el-page-header>
          <!-- <div>
          <i class="el-icon-circle-plus-outline c-pointer h-primary" @click="addRole()"></i>
          <i class="el-icon-edit c-pointer c-m-l-15 h-primary" @click="editRole()"></i>
          <i class="el-icon-delete c-pointer c-m-l-15 h-danger" @click="removeRole()"></i>
        </div> -->
        </div>
        <div class="left-content row">
          <div class="content-group">
            <div
              v-for="(item, i) in extsItems"
              :key="i"
              class="content-item"
              :class="activeData.name == item.name ? 'is-selected' : ''"
              @click="handleClick(item)"
            >
              {{ item.name }}
            </div>
          </div>
        </div>
      </div>
      <div class="right-box func-tree c-p-10">
        <el-form
          :label-position="'left'"
          label-width="80px"
          :model="activeData.value"
          style="flex:1;overflow: auto;padding-right: 20px;"
        >
          <template v-for="(item, index) of activeData.value">
            <template v-if="typeof item == 'object'">
              <el-form-item :label="index" :key="index" class="object-form-item">
                <template v-for="(itemItem, itemIndex) of activeData.value[index]">
                  <el-form-item :label="itemIndex" :key="itemIndex">
                    <template v-for="(attribItem, attribIndex) of itemItem">
                      <el-form-item label-width="30px" :label="attribIndex" :key="attribIndex">
                        <el-input v-model="itemItem[attribIndex]">
                          <el-button slot="append">
                            <el-popover placement="right" width="400" trigger="click">
                              <el-input
                                v-model="itemItem[attribIndex]"
                                type="textarea"
                                rows="30"
                              ></el-input>
                              <el-button slot="reference" icon="el-icon-zoom-in"></el-button>
                            </el-popover>
                          </el-button>
                        </el-input>
                      </el-form-item>
                    </template>
                  </el-form-item>
                </template>
              </el-form-item>
            </template>
            <template v-else>
              <el-form-item :label="index" :key="index">
                <el-input v-model="activeData.value[index]">
                  <el-button slot="append">
                    <el-popover placement="right" width="400" trigger="click">
                      <el-input
                        v-model="activeData.value[index]"
                        type="textarea"
                        rows="30"
                      ></el-input>
                      <el-button slot="reference" icon="el-icon-zoom-in"></el-button>
                    </el-popover>
                  </el-button>
                </el-input>
              </el-form-item>
            </template>
          </template>
        </el-form>
        <div
          style="border-top: 1px #f2f2f2 solid;padding-top: 10px;display: flex;justify-content: flex-end;"
        >
          <el-button type="primary" @click="doSaveSeting">保持设置</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  activated() {
    window.$this = this;
  },
  name: 'qiyuesuoPDF',
  data() {
    return {
      extsItems: [], //左侧所有exts细项
      activeData: {}, //当前选择对象、右侧编辑的属性表单
      formData: {},
      openDetail: false,
      fpi: {
        data: []
        // data: [
        //   {
        //     _id: '5199793476783590248',
        //     url: 'https://openapi.qiyuesuo.cn',
        //     accessKey: 'xPYbvFA5Vz',
        //     accessSecret: 'fcoLiIgPjupiMBIgWPd2XDkZwkuTkJ',
        //     sealId: 2703825372939555342,
        //     companyName: '北京顶之美建筑科技有限责任公司',
        //     companyType: '1',
        //     companyId: '2741491010155581905',
        //     phone: '18514219060',
        //     exts: {
        //       '1_bg': {
        //         expireDay: '20',
        //         preScript:
        //           'import com.fsgo.entity.basic.Contract\nimport com.fsgo.entity.basic.Partner\nimport com.osg.framework.BaseException\nimport com.osg.framework.util.StringUtils\nimport com.qiyuesuo.sdk.v2.bean.Action\nimport com.qiyuesuo.sdk.v2.bean.Signatory\nimport com.qiyuesuo.sdk.v2.bean.User\n\nSystem.out.println("*********************契约锁前置脚本======================");\n\nString supplementTreatyId=qiYueSuo.sid   //增减项id\nprintln "增减项id="+supplementTreatyId\nprintln "增减项id="+supplementTreatyId\nprintln "增减项id="+supplementTreatyId\n//pdf 数据\nMap tmpData=mongoTemplate.findById(supplementTreatyId,HashMap,"frm_1340835581184723420_contractSupplementTreaty");\nctx.put("tmpData",tmpData)\nString contractId=tmpData.get("contractId")+""  //所对应合同id\n\nprintln "所对应合同id="+contractId\nprintln "所对应合同id="+contractId\nprintln "所对应合同id="+contractId\n//草稿\nMap draftData=new HashMap();\n\nContract contract=mongoTemplate.findById(contractId,Contract.class);\nString partnerId = contract.getPartnerId();\nPartner partner = mongoTemplate.findById(partnerId, Partner.class);\nMap<String, Object> exts = partner.getExts();\nString companySealCode = (String) exts.get("qysSealCode");\nString companyOperatorPhone = (String) exts.get("qysSealAdminPhone");//伙伴上配置\n\nprintln "companySealCode="+companySealCode\nprintln "companyOperatorPhone="+companyOperatorPhone\nif (StringUtils.isEmpty(companyOperatorPhone))\n    throw new BaseException("伙伴的契约锁经办人手机号未进行维护！");\n\n//草稿数据准备\nList tags=new ArrayList();\ntags.add("防水")\ntags.add("增项")\ndraftData.put("tags",tags)\ndraftData.put("subject","北京顶之美建筑科技有限责任公司合同增项")//主题\n\n\nList signatoryList=new ArrayList();\n\n//个人签署方\nSignatory personal = new Signatory();\npersonal.setTenantType("PERSONAL");\npersonal.setTenantName(contract.getContactsName());\npersonal.setSerialNo(0);\npersonal.setReceiver(new User(contract.getContactsPhone(), "MOBILE"));\nsignatoryList.add(personal)\n\n//发起方cat docker.log | grep "契约锁回调" -C 10\nSignatory platform = new Signatory();\nplatform.setTenantType("COMPANY");\nplatform.setTenantName("北京顶之美建筑科技有限责任公司");\nplatform.setReceiver(new User("18600971879", "MOBILE"));\nplatform.setSerialNo(1);\nAction sealAction = new Action("COMPANY", 1);\nsealAction.setSealId(Long.parseLong("2703825372939555342"));//印章id\nsealAction.setAutoSign(true)\nplatform.addAction(sealAction);\nsignatoryList.add(platform)\n\n////伙伴签署方\nSignatory company = new Signatory();\ncompany.setTenantType("COMPANY");\ncompany.setTenantName(partner.getName());\ncompany.setReceiver(new User(companyOperatorPhone, "MOBILE"));\ncompany.setSerialNo(2);\nAction operatorAction = new Action("OPERATOR", 1);\ncompany.addAction(operatorAction);\nAction companyAction = new Action("COMPANY", 2);\ncompanyAction.setSealId(Long.parseLong(companySealCode));\ncompany.addAction(companyAction);\nsignatoryList.add(company)\ndraftData.put("signatoryList",signatoryList);\nctx.put("draftData",draftData)\n\n\n\n',
        //         categoryId: '2741491010155581905',
        //         tmpPath: '/WEB-INF/template/contractSupplementTreaty.pdf',
        //         fontPath: '/WEB-INF/template/LISHU.TTF',
        //         title: '增减项合同',
        //         serialNo_0: {
        //           COMPANY: {
        //             offsetX: '0.3',
        //             offsetY: '0.5',
        //             page: '1'
        //           },
        //           PERSONAL: {
        //             offsetX: '0.4',
        //             offsetY: '0.5',
        //             page: '1'
        //           },
        //           TIMESTAMP: {
        //             offsetX: '0.5',
        //             offsetY: '0.5',
        //             page: '1'
        //           },
        //           ACROSS_PAGE: {
        //             offsetX: '0.6',
        //             offsetY: '0.5',
        //             page: '1'
        //           }
        //         },
        //         serialNo_1: {
        //           COMPANY: {
        //             offsetX: '0.3',
        //             offsetY: '0.6',
        //             page: '1'
        //           },
        //           ACROSS_PAGE: {
        //             offsetX: '0.6',
        //             offsetY: '0.6',
        //             page: '1'
        //           }
        //         },
        //         serialNo_2: {
        //           COMPANY: {
        //             offsetX: '0.3',
        //             offsetY: '0.7',
        //             page: '1'
        //           },
        //           PERSONAL: {
        //             offsetX: '0.4',
        //             offsetY: '0.7',
        //             page: '1'
        //           },
        //           ACROSS_PAGE: {
        //             offsetX: '0.6',
        //             offsetY: '0.7',
        //             page: '1'
        //           }
        //         }
        //       },
        //       '1_tk_1': {
        //         expireDay: '20',
        //         preScript:
        //           'import com.fsgo.entity.basic.Contract\nimport com.fsgo.entity.basic.Partner\nimport com.osg.framework.BaseException\nimport com.osg.framework.util.StringUtils\nimport com.qiyuesuo.sdk.v2.bean.Action\nimport com.qiyuesuo.sdk.v2.bean.Signatory\nimport com.qiyuesuo.sdk.v2.bean.User\n\nSystem.out.println("*********************契约锁前置脚本======================");\n\nString supplementTreatyId=qiYueSuo.sid   //增减项id\nprintln "增减项id="+supplementTreatyId\nprintln "增减项id="+supplementTreatyId\nprintln "增减项id="+supplementTreatyId\n//pdf 数据\nMap tmpData=mongoTemplate.findById(supplementTreatyId,HashMap,"frm_1340835581184723420_contractSupplementTreaty");\nctx.put("tmpData",tmpData)\nString contractId=tmpData.get("contractId")+""  //所对应合同id\n\nprintln "所对应合同id="+contractId\nprintln "所对应合同id="+contractId\nprintln "所对应合同id="+contractId\n//草稿\nMap draftData=new HashMap();\n\nContract contract=mongoTemplate.findById(contractId,Contract.class);\nString partnerId = contract.getPartnerId();\nPartner partner = mongoTemplate.findById(partnerId, Partner.class);\nMap<String, Object> exts = partner.getExts();\nString companySealCode = (String) exts.get("qysSealCode");\nString companyOperatorPhone = (String) exts.get("qysSealAdminPhone");//伙伴上配置\n\nprintln "companySealCode="+companySealCode\nprintln "companyOperatorPhone="+companyOperatorPhone\nif (StringUtils.isEmpty(companyOperatorPhone))\n    throw new BaseException("伙伴的契约锁经办人手机号未进行维护！");\n\n//草稿数据准备\nList tags=new ArrayList();\ntags.add("防水")\ntags.add("增项")\ndraftData.put("tags",tags)\ndraftData.put("subject","北京顶之美建筑科技有限责任公司合同增项")//主题\n\n\nList signatoryList=new ArrayList();\n\n//个人签署方\nSignatory personal = new Signatory();\npersonal.setTenantType("PERSONAL");\npersonal.setTenantName(contract.getContactsName());\npersonal.setSerialNo(0);\npersonal.setReceiver(new User(contract.getContactsPhone(), "MOBILE"));\nsignatoryList.add(personal)\n\n//发起方cat docker.log | grep "契约锁回调" -C 10\nSignatory platform = new Signatory();\nplatform.setTenantType("COMPANY");\nplatform.setTenantName("北京顶之美建筑科技有限责任公司");\nplatform.setReceiver(new User("18600971879", "MOBILE"));\nplatform.setSerialNo(1);\nAction sealAction = new Action("COMPANY", 1);\nsealAction.setSealId(Long.parseLong("2703825372939555342"));//印章id\nsealAction.setAutoSign(true)\nplatform.addAction(sealAction);\nsignatoryList.add(platform)\n\n////伙伴签署方\nSignatory company = new Signatory();\ncompany.setTenantType("COMPANY");\ncompany.setTenantName(partner.getName());\ncompany.setReceiver(new User(companyOperatorPhone, "MOBILE"));\ncompany.setSerialNo(2);\nAction operatorAction = new Action("OPERATOR", 1);\ncompany.addAction(operatorAction);\nAction companyAction = new Action("COMPANY", 2);\ncompanyAction.setSealId(Long.parseLong(companySealCode));\ncompany.addAction(companyAction);\nsignatoryList.add(company)\ndraftData.put("signatoryList",signatoryList);\nctx.put("draftData",draftData)\n\n\n\n',
        //         categoryId: '2741491010155581905',
        //         tmpPath: '/WEB-INF/template/退款说明（客户版）.pdf',
        //         fontPath: '/WEB-INF/template/LISHU.TTF',
        //         title: '退款说明(客户版)合同',
        //         serialNo_0: {
        //           COMPANY: {
        //             offsetX: '0.3',
        //             offsetY: '0.5',
        //             page: '1'
        //           },
        //           PERSONAL: {
        //             offsetX: '0.4',
        //             offsetY: '0.5',
        //             page: '1'
        //           },
        //           TIMESTAMP: {
        //             offsetX: '0.5',
        //             offsetY: '0.5',
        //             page: '1'
        //           },
        //           ACROSS_PAGE: {
        //             offsetX: '0.6',
        //             offsetY: '0.5',
        //             page: '1'
        //           }
        //         },
        //         serialNo_1: {
        //           COMPANY: {
        //             offsetX: '0.3',
        //             offsetY: '0.6',
        //             page: '1'
        //           },
        //           ACROSS_PAGE: {
        //             offsetX: '0.6',
        //             offsetY: '0.6',
        //             page: '1'
        //           }
        //         },
        //         serialNo_2: {
        //           COMPANY: {
        //             offsetX: '0.3',
        //             offsetY: '0.7',
        //             page: '1'
        //           },
        //           PERSONAL: {
        //             offsetX: '0.4',
        //             offsetY: '0.7',
        //             page: '1'
        //           },
        //           ACROSS_PAGE: {
        //             offsetX: '0.6',
        //             offsetY: '0.7',
        //             page: '1'
        //           }
        //         }
        //       },
        //       '1_tk_2': {
        //         expireDay: '20',
        //         preScript:
        //           'import com.fsgo.entity.basic.Contract\nimport com.fsgo.entity.basic.Partner\nimport com.osg.framework.BaseException\nimport com.osg.framework.util.StringUtils\nimport com.qiyuesuo.sdk.v2.bean.Action\nimport com.qiyuesuo.sdk.v2.bean.Signatory\nimport com.qiyuesuo.sdk.v2.bean.User\n\nSystem.out.println("*********************契约锁前置脚本======================");\n\nString supplementTreatyId=qiYueSuo.sid   //增减项id\nprintln "增减项id="+supplementTreatyId\nprintln "增减项id="+supplementTreatyId\nprintln "增减项id="+supplementTreatyId\n//pdf 数据\nMap tmpData=mongoTemplate.findById(supplementTreatyId,HashMap,"frm_1340835581184723420_contractSupplementTreaty");\nctx.put("tmpData",tmpData)\nString contractId=tmpData.get("contractId")+""  //所对应合同id\n\nprintln "所对应合同id="+contractId\nprintln "所对应合同id="+contractId\nprintln "所对应合同id="+contractId\n//草稿\nMap draftData=new HashMap();\n\nContract contract=mongoTemplate.findById(contractId,Contract.class);\nString partnerId = contract.getPartnerId();\nPartner partner = mongoTemplate.findById(partnerId, Partner.class);\nMap<String, Object> exts = partner.getExts();\nString companySealCode = (String) exts.get("qysSealCode");\nString companyOperatorPhone = (String) exts.get("qysSealAdminPhone");//伙伴上配置\n\nprintln "companySealCode="+companySealCode\nprintln "companyOperatorPhone="+companyOperatorPhone\nif (StringUtils.isEmpty(companyOperatorPhone))\n    throw new BaseException("伙伴的契约锁经办人手机号未进行维护！");\n\n//草稿数据准备\nList tags=new ArrayList();\ntags.add("防水")\ntags.add("增项")\ndraftData.put("tags",tags)\ndraftData.put("subject","北京顶之美建筑科技有限责任公司合同增项")//主题\n\n\nList signatoryList=new ArrayList();\n\n//个人签署方\nSignatory personal = new Signatory();\npersonal.setTenantType("PERSONAL");\npersonal.setTenantName(contract.getContactsName());\npersonal.setSerialNo(0);\npersonal.setReceiver(new User(contract.getContactsPhone(), "MOBILE"));\nsignatoryList.add(personal)\n\n//发起方cat docker.log | grep "契约锁回调" -C 10\nSignatory platform = new Signatory();\nplatform.setTenantType("COMPANY");\nplatform.setTenantName("北京顶之美建筑科技有限责任公司");\nplatform.setReceiver(new User("18600971879", "MOBILE"));\nplatform.setSerialNo(1);\nAction sealAction = new Action("COMPANY", 1);\nsealAction.setSealId(Long.parseLong("2703825372939555342"));//印章id\nsealAction.setAutoSign(true)\nplatform.addAction(sealAction);\nsignatoryList.add(platform)\n\n////伙伴签署方\nSignatory company = new Signatory();\ncompany.setTenantType("COMPANY");\ncompany.setTenantName(partner.getName());\ncompany.setReceiver(new User(companyOperatorPhone, "MOBILE"));\ncompany.setSerialNo(2);\nAction operatorAction = new Action("OPERATOR", 1);\ncompany.addAction(operatorAction);\nAction companyAction = new Action("COMPANY", 2);\ncompanyAction.setSealId(Long.parseLong(companySealCode));\ncompany.addAction(companyAction);\nsignatoryList.add(company)\ndraftData.put("signatoryList",signatoryList);\nctx.put("draftData",draftData)\n\n\n\n',
        //         categoryId: '2741491010155581905',
        //         tmpPath: '/WEB-INF/template/退款说明（服务商垫资版）.pdf',
        //         fontPath: '/WEB-INF/template/LISHU.TTF',
        //         title: '退款说明(服务商垫资版)合同',
        //         serialNo_0: {
        //           COMPANY: {
        //             offsetX: '0.3',
        //             offsetY: '0.5',
        //             page: '1'
        //           },
        //           PERSONAL: {
        //             offsetX: '0.4',
        //             offsetY: '0.5',
        //             page: '1'
        //           },
        //           TIMESTAMP: {
        //             offsetX: '0.5',
        //             offsetY: '0.5',
        //             page: '1'
        //           },
        //           ACROSS_PAGE: {
        //             offsetX: '0.6',
        //             offsetY: '0.5',
        //             page: '1'
        //           }
        //         },
        //         serialNo_1: {
        //           COMPANY: {
        //             offsetX: '0.3',
        //             offsetY: '0.6',
        //             page: '1'
        //           },
        //           ACROSS_PAGE: {
        //             offsetX: '0.6',
        //             offsetY: '0.6',
        //             page: '1'
        //           }
        //         },
        //         serialNo_2: {
        //           COMPANY: {
        //             offsetX: '0.3',
        //             offsetY: '0.7',
        //             page: '1'
        //           },
        //           PERSONAL: {
        //             offsetX: '0.4',
        //             offsetY: '0.7',
        //             page: '1'
        //           },
        //           ACROSS_PAGE: {
        //             offsetX: '0.6',
        //             offsetY: '0.7',
        //             page: '1'
        //           }
        //         }
        //       }
        //     }
        //   }
        // ]
      },
      row: {}, //当前设置的数据
      searchValue: ''
    };
  },
  mounted() {
    this.doInit();
  },
  methods: {
    doInit() {
      window.$this = this;
      this.openDetail = false;
      this.formData = {};
      this.getData();
    },
    //获取所有角色
    getData() {
      // this.extsItems = [];
      // for (let key in this.mockData.exts) {
      //   this.extsItems.push({
      //     name: key,
      //     value: this.mockData.exts[key]
      //   });
      // }
      // this.activeData = this.extsItems[0];
      //   console.log(this.activeData);
      let params = {
        page: this.fpi.page || 1,
        rows: this.fpi.rows || 20,
        'regex:phone|string#or': this.searchValue,
        sortField: 'createTime',
        sortOrder: 'desc',
        'is:state|integer#and': 1
      };
      this.osg.ajax('basic/qiyuesuo/query.do', params, res => {
        this.fpi = res;
        console.log(this.fpi);
        this.$nextTick(() => {
          this.$refs.table.doLayout();
          this.$forceUpdate();
        });
      });
    },
    doNew() {
      this.doInit();
      this.openDetail = true;
    },
    pageSizeChange(pageSize) {
      this.fpi.rows = pageSize;
      this.getData();
    },
    pageChange(currentPage) {
      this.fpi.page = currentPage;
      this.getData();
    },
    //编辑
    doEdit(row) {
      row = this.$util.deepCopy(row);
      delete row.exts;
      this.formData = row;
      this.openDetail = true;
    },
    //设置
    doSeting(row) {
      row = this.$util.deepCopy(row);
      this.row = row;
      for (let key in row.exts) {
        this.extsItems.push({
          name: key,
          value: row.exts[key],
          _id: row._id
        });
      }
      this.activeData = this.extsItems[0]; //当前编辑的属性表单
      this.activeData._id = row._id;
    },
    doSave() {
      this.osg.ajax('basic/qiyuesuo/upsert.do', this.formData, () => {
        this.doInit();
        this.getData();
        this.osg.toast('保存成功！');
      });
    },
    //选择
    handleClick(item) {
      this.activeData = this.$util.deepCopy(item);
    },
    doSaveSeting() {
      console.log(this.activeData);
      this.osg.ajax(
        'basic/qiyuesuo/upsertExts.do',
        {
          qiYueSuoDefId: this.activeData._id,
          value: JSON.stringify(this.activeData.value),
          key: this.activeData.name
        },
        () => {
          this.doInit();
          this.getData();
          this.osg.toast('保存成功！');
        }
      );
    },
    goBack() {
      this.extsItems = [];
      this.$forceUpdate();
      console.log(this.extsItems);
    }
  }
};
</script>
<style scoped>
/* 数据权限选择按钮 */
.func-tree .el-radio-group {
  display: flex;
  flex-direction: column;
}
.func-tree .el-radio-group > label {
  width: 200px;
  margin: 10px;
}
.row .content-item {
  font-size: initial !important;
}
</style>
<style>
#app .object-form-item .el-form-item__content > div {
  margin-left: 28px;
  max-width: calc(100% - 48px);
}
/*菜单权限树*/
.func-tree .el-form-item__label {
  text-align: center !important;
}
.func-tree .el-tree-node__content {
  padding: 0px 10px 0px 0;
  margin: 2px 0px;
  height: auto;
}
.func-tree
  .el-tree
  > .el-tree-node
  > .el-tree-node__children
  > .is-expanded
  > .el-tree-node__children
  > .is-expanded {
  display: inline-block;
}
.func-tree
  .el-tree
  > .el-tree-node
  > .el-tree-node__children
  > .is-expanded
  > .el-tree-node__children {
  padding-left: 100px;
}
.func-tree
  .el-tree
  > .el-tree-node
  > .el-tree-node__children
  > .is-expanded
  > .el-tree-node__children
  > .is-expanded
  > .el-tree-node__content {
  padding-left: 0 !important;
  height: auto;
}
</style>
